class PrintBatchController {
    /*@ngInject*/
    constructor(Auth, $state, $translate, $scope, User, ShipmentService) {
        this.$translate = $translate;
        this.$state = $state;
        this.Auth = Auth;
        this.$scope = $scope;
        this.ShipmentService = ShipmentService;
        this.printData = [];
        this.printData = undefined;
        this.tracingIds = [];
        this.model = {
            shipmentDetails: [],
            barcodeOptions:
            {
                format: 'CODE128', lineColor: '#030303', width: 3, height: 110, displayValue: true,
                font: 'monospace', textAlign: 'center', textPosition: 'bottom', textMargin: 0, fontSize: 25,
                marginTop: 0, marginBottom: 0
            }
        }
        this.printCompletedShipmentData = [];
        this.printCompletedShipmentData = undefined;
        this.currentStat = null;
        // this.pickupDate = "";
        // this.deliveryDate = "";
    }

    $onInit() {
        if (window.opener && window.opener.w && window.opener.w.printCompletedShipmentData) {

            this.printCompletedShipmentData = window.opener.w.printCompletedShipmentData;
            this.currentStat = 'completedStat';

            this.batchId = printCompletedShipmentData.batchId;
            this.locationId = printCompletedShipmentData.locationId;

            return this.ShipmentService.printCompletedShipments(this.batchId, this.locationId)
                .then((res) => {
                    this.printCompletedShipmentData = res.results;
                    const rowsPerColumn = 30;
                    const columns = Math.ceil(this.printCompletedShipmentData.length / rowsPerColumn);

                    // Create the column data
                    const columnData = [];
                    for (let i = 0; i < columns; i++) {
                        const startIndex = i * rowsPerColumn;
                        const endIndex = startIndex + rowsPerColumn;
                        columnData.push(this.printCompletedShipmentData.slice(startIndex, endIndex));
                    }

                    // Use the columnData array in your template
                    this.model.columnn = columnData;
                    setTimeout(() => {
                        window.print();
                    }, 1500)
                })
                .catch((err) => {
                    console.log(err);
                })
        }

        if (window.opener && window.opener.w && window.opener.w.printData) {
            this.printData = window.opener.w.printData;
            this.tracingIds = printData.trackingIds;
            this.currentStat = 'DeliveryManifestStat';

            if (printData.shipmentDetails) {
                this.currentStat = 'pendingStat';
                this.model.shipmentDetails = printData.shipmentDetails;               

                const rowsPerColumn = 30;
                const columns = Math.ceil(this.model.shipmentDetails.length / rowsPerColumn);

                // Create the column data
                const columnData = [];
                for (let i = 0; i < columns; i++) {
                    const startIndex = i * rowsPerColumn;
                    const endIndex = startIndex + rowsPerColumn;
                    columnData.push(this.model.shipmentDetails.slice(startIndex, endIndex));
                }

                // Use the columnData array in your template
                this.model.columnData = columnData;
            }

            // this.pickupDate = printData.pickupDate;
            // this.deliveryDate = printData.deliveryDate;

            return this.ShipmentService.batchRecords(this.tracingIds)
                .then((res) => {
                    this.printData = res.results;
                    setTimeout(() => {
                        window.print();
                    }, 1500)
                })
                .catch((err) => {
                    console.log(err);
                })
        }
    }
}

export default PrintBatchController;


// WEBPACK FOOTER //
// ./client/app/components/shipment_batch/print/print_batch.controller.js